import React, { useState, useEffect } from "react";
import { getAllPayments, updatePayment, createPayment } from "../services/api";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
} from "@mui/material";
import { toast } from "react-toastify";

const PaymentManagement = () => {
  const [payments, setPayments] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newPayment, setNewPayment] = useState({
    orgId: "",
    userId: "",
    paymentMethod: "",
    paymentThrough: "",
    status: "completed",
  });

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      const res = await getAllPayments();
      setPayments(res.data.payments);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch payments");
    }
  };

  // Open and close modals
  const handleOpenEditModal = (payment) => {
    setSelectedPayment(payment);
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setSelectedPayment(null);
    setOpenEditModal(false);
  };

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setOpenCreateModal(false);
    setNewPayment({
      orgId: "",
      userId: "",
      paymentMethod: "",
      paymentThrough: "",
      status: "completed",
    });
  };

  // Update payment
  const handleUpdatePayment = async () => {
    try {
      await updatePayment(selectedPayment._id, selectedPayment);
      toast.success("Payment updated successfully");
      handleCloseEditModal();
      fetchPayments();
    } catch (error) {
      toast.error("Failed to update payment");
    }
  };

  // Create payment
  const handleCreatePayment = async () => {
    try {
      await createPayment(newPayment);
      toast.success("Payment created successfully");
      handleCloseCreateModal();
      fetchPayments();
    } catch (error) {
      toast.error("Failed to create payment");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Payment Management</h2>

      <Button variant="contained" color="primary" onClick={handleOpenCreateModal} style={{ marginBottom: 10 }}>
        Create Payment
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Org ID</TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Payment Method</TableCell>
            <TableCell>Payment Through</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {payments.map((payment) => (
            <TableRow key={payment._id}>
              <TableCell>{payment.orgId}</TableCell>
              <TableCell>{payment.userId}</TableCell>
              <TableCell>{payment.paymentMethod}</TableCell>
              <TableCell>{payment.paymentThrough}</TableCell>
              <TableCell>{payment.status}</TableCell>
              <TableCell>
                <Button variant="contained" color="primary" onClick={() => handleOpenEditModal(payment)}>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Edit Payment Modal */}
      <Modal open={openEditModal} onClose={handleCloseEditModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 3,
            boxShadow: 24,
            borderRadius:"8px"
          }}
        >
          <h3>Edit Payment</h3>
          <TextField
            label="Payment Method"
            value={selectedPayment?.paymentMethod || ""}
            onChange={(e) => setSelectedPayment({ ...selectedPayment, paymentMethod: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Payment Through"
            value={selectedPayment?.paymentThrough || ""}
            onChange={(e) => setSelectedPayment({ ...selectedPayment, paymentThrough: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            select
            label="Status"
            value={selectedPayment?.status || ""}
            onChange={(e) => setSelectedPayment({ ...selectedPayment, status: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          >
            <MenuItem value="completed">Completed</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
          </TextField>
          <Box sx={{display:"flex", justifyContent:"end"}}>
          <Button variant="contained" color="primary" onClick={handleUpdatePayment} style={{ marginTop: 10 }}>
            Update
          </Button>
          </Box>
          
        </Box>
      </Modal>

      {/* Create Payment Modal */}
      <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 3,
            boxShadow: 24,
            borderRadius:"8px"
          }}
        >
          <h3>Create Payment</h3>
          <TextField
            label="Org ID"
            value={newPayment.orgId}
            onChange={(e) => setNewPayment({ ...newPayment, orgId: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="User ID"
            value={newPayment.userId}
            onChange={(e) => setNewPayment({ ...newPayment, userId: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Payment Method"
            value={newPayment.paymentMethod}
            onChange={(e) => setNewPayment({ ...newPayment, paymentMethod: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            label="Payment Through"
            value={newPayment.paymentThrough}
            onChange={(e) => setNewPayment({ ...newPayment, paymentThrough: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          />
          <TextField
            select
            label="Status"
            value={newPayment.status}
            onChange={(e) => setNewPayment({ ...newPayment, status: e.target.value })}
            fullWidth
            margin="dense"
            size="small"
          >
            <MenuItem value="completed">Completed</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
          </TextField>
         <Box sx={{display:"flex",justifyContent:"end"}}>
         <Button variant="contained" color="primary" onClick={handleCreatePayment} style={{ marginTop: 10, }}>
            Create
          </Button>
         </Box>
          
        </Box>
      </Modal>
    </div>
  );
};

export default PaymentManagement;
